import React, { forwardRef, useState } from 'react'
import styles from './FloatingAuthInput.module.css'
import { Eye, EyeOff, Mail } from 'lucide-react';
import Show from 'Components/Show/Show';
const FloatingAuthInput = forwardRef(({ id, label, type, placeholder, required, onKeyPress, name, onChange, value, autoFocus }, ref) => {
    const [showPassword, setShowPassword] = useState(false);

    const isPassword = type === 'password';
    const inputType = isPassword ? (showPassword ? 'text' : 'password') : type;

    const togglePasswordVisibility = () => {
        setShowPassword(prev => !prev);
    };

    return (
        <div className={styles.field}>

            <input
                ref={ref}
                type={inputType}
                name={name}
                value={value}
                onChange={onChange}
                onKeyPress={onKeyPress}
                autoFocus={autoFocus}
                required={required}

                className='w-full px-4 py-3 transition-all duration-200 border border-gray-300 rounded-lg focus:border-primary-600 focus:outline-none focus:ring-2 focus:ring-primary-100' placeholder={placeholder} id={id} />


            <label className={'absolute left-3 transition-all duration-200 pointer-events-none text-gray-500 top-3   bg-white px-1 z-10'} for={id}>{label} <span className={styles.required}>*</span></label>
            {isPassword && (
                <button
                    type="button"
                    onClick={togglePasswordVisibility}
                    className="absolute text-gray-500 transition-colors right-3 top-3 hover:text-primary-600"
                >
                    {showPassword ? <Eye size={20} /> : <EyeOff size={20} />}
                </button>
            )}
            <Show when={type === 'email'}>
                <Mail className="absolute text-gray-500 transition-colors right-3 top-3 hover:text-primary-600" size={20} />
            </Show>
        </div>
    )
})

export default FloatingAuthInput